import { ITableConfig, ITableRowConfig } from 'components/Table/types';

const rowConfigs: ITableRowConfig[] = [
  { header: 'Name', flexValue: 1, isSortable: false },
  { header: 'Email', flexValue: 1.5, isSortable: false },
];

export const tableConfig: ITableConfig = {
  rowConfigs: rowConfigs,
  extraActionsFlexValue: 0.1,
};

export const USERS_PER_PAGE = 10;
